import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import AuthLayout from '../layouts/AuthLayout.vue'
import AppLayout from '../layouts/AppLayout.vue'
import { getStorageData } from '../services/localstorage'
import { StorageKeys } from '../services/localstorage/localStorageType'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'homes' },
  },
  {
    name: 'admin',
    path: '/',
    component: AppLayout,
    meta: { requiresAuth: true },
    redirect: { name: 'homes' },
    children: [
      {
        name: 'settings',
        path: 'settings',
        component: () => import('../pages/settings/Settings.vue'),
      },
      {
        name: 'homes',
        path: 'homes',
        component: () => import('../pages/homes/HomesPage.vue'),
      },
      {
        name: 'services',
        path: 'services',
        component: () => import('../pages/services/ServicesPage.vue'),
      },
      {
        name: 'galleries',
        path: 'galleries',
        component: () => import('../pages/galleries/GalleriesPage.vue'),
      },
      {
        name: 'libraries',
        path: 'libraries',
        component: () => import('../pages/libraries/LibrariesPage.vue'),
      },
      {
        name: 'slideshow',
        path: 'slideshow',
        component: () => import('../pages/slideshow/SlideshowPage.vue'),
      },
    ],
  },
  {
    path: '/auth',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('../pages/auth/Login.vue'),
      },
      {
        name: 'signup',
        path: 'signup',
        component: () => import('../pages/auth/Signup.vue'),
      },
      {
        name: 'recover-password',
        path: 'recover-password',
        component: () => import('../pages/auth/RecoverPassword.vue'),
      },
      {
        name: 'recover-password-email',
        path: 'recover-password-email',
        component: () => import('../pages/auth/CheckTheEmail.vue'),
      },
      {
        path: '',
        redirect: { name: 'login' },
      },
    ],
  },
  {
    name: '404',
    path: '/404',
    component: () => import('../pages/404.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth)
  const getUser = await getStorageData(StorageKeys.ADMINUSER)

  // console.log('getUser', getUser)

  if (requiresAuth && !getUser) {
    next({ name: 'login' })
  } else {
    next()
  }
})

export default router
